import t from 'react-translate';
import { tooltipZIndex } from 'athena/components/constants';
import { AuthenticationStatus, IntegrationAuth } from 'redux/schemas/models/mentoring-program-sessions';

import { css } from '@emotion/react';
import { gray2, gray4, gray7 } from 'styles/global_defaults/colors';

import NvIcon from 'shared/components/nv-icon';
import NvTooltip from 'shared/components/nv-tooltip';
import ClickableContainer from 'components/clickable-container';
import VirtualMeetingButton from './virtual-meeting-button';

const styles = css`
  .virtual-meeting-title {
    i {
      cursor: pointer;
      color: ${gray4};
    }
  }
  .settings {
    &:hover {
      background-color: ${gray7};
      border-radius: 100px;
      i {
        color: ${gray2};
      }
    }
  }
`;

type VirtualMeetingProps = {
  sessionId: number;
  integrations: IntegrationAuth;
  openIntegrationsModal?: () => void;
};

const VirtualMeeting = (props: VirtualMeetingProps) => {
  const { sessionId, integrations, openIntegrationsModal } = props;
  const { source = [] } = integrations || {};

  const translations = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.VIRTUAL_MEETING;

  const isOnlyOneAuthenticated = () => {
    const unauthenticated = Object.values(integrations).filter((integration: any) => (
      integration.authenticatedStatus === AuthenticationStatus.AUTHENTICATED
    ));
    return unauthenticated.length === 1;
  };
  const hasMissingIntegration = source?.length === 2 ? isOnlyOneAuthenticated() : false;

  return (
    <>
      <div
        css={styles}
        className='virtual-meeting d-flex justify-content-between align-items-center mb-4'
      >
        <div className='d-flex text-regular session-time virtual-meeting-title align-items-center'>
          {translations.TITLE()}
          {hasMissingIntegration && (
            <NvTooltip
              zIndex={tooltipZIndex}
              text={translations.TOOLTIP()}
              placement='top'
              enabled
            >
              <ClickableContainer
                className='ml-1 settings p-2'
                onClick={openIntegrationsModal}
              >
                <NvIcon icon='3rd-party-settings' size='smallest' />
              </ClickableContainer>
            </NvTooltip>
          )}
        </div>
        <VirtualMeetingButton
          integrations={integrations}
          openIntegrationsModal={openIntegrationsModal}
        />
      </div>
    </>
  );
};

export default VirtualMeeting;
